export default{
  getStatsBlock(state){
    return state.statsBlock
  },
  getStatMetadata(state){
    return state.metadata
  },

}
